<template>
  <div>
    <b-toast id="user-tutorial"
             toaster='b-toaster-bottom-left'
             variant="warning"
             no-auto-hide
             no-close-button>
      <template v-if="!timeout_enabled">
        <div id="help">
          <img id="txs_filter_example_icon"
               v-b-modal.txs_filter_help
               src="../assets/question.svg" />

          <p>
          <b>Do you need help?</b>
          </p>
        </div>

        <div id="buttons">
        <b-button @click="no" variant="primary">
          No
        </b-button>

        <b-button @click="yes" variant="primary">
          Yes
        </b-button>
        </div>
      </template>

      <template v-else>
        <div id="account">
          <b-spinner type="grow" />

          <p>
          <b>OK... if you change you mind,
            you can enable the tutorial on your Account page
          </b>
          </p>
        </div>
      </template>
    </b-toast>

    <UserTutorialPopup v-for="(tutorial, ti) in tutorials"
                       v-show="tutorial_active(ti)"
                       :id="ti"
                       :tutorial="tutorial"
                       :key="'tutorial' + ti"
                       :ref="'tutorial' + ti" />
  </div>
</template>

<script>
// Set to always remove cookie on instantiation
const FORCE_CLEAR = false;

import UserTutorialPopup from './UserTutorialPopup'
import tutorials from '../assets/tutorial.json'

export default{
  name: 'UserTutorial',

  components : {UserTutorialPopup},

  data : function(){
    return {
      timeout : false,
      current : -1
    };
  },

  computed : {
    tutorials () {
      return tutorials
    },

    timeout_enabled : function(){
      return this.timeout;
    },

    interacted : {
      get() {
        return this.$cookies.get('userTutorial');
      },

      set(v) {
        this.$cookies.set("userTutorial", v);
      }
    },

    current_tutorial (){
      return tutorials[this.current];
    },

    current_popup (){
      return this.$refs['tutorial' + this.current][0];
    }
  },

  methods : {
    no () {
      this.timeout = true;
      this.interacted = true;

      setTimeout(function(){
        this.$bvToast.hide('user-tutorial');
      }.bind(this), 5000);
    },

    yes () {
      this.$bvToast.hide('user-tutorial');
      this.interacted = true;
      this.next_tutorial();
    },

    tutorial_active (ti){
      return this.current == ti;
    },

    next_tutorial (){
      if(this.current == tutorials.length - 1) return;
      if(this.current > -1) this.current_popup.close();

      this.current += 1;
      this.current_popup.open();
    },

    prev_tutorial (){
      if(this.current == 0) return;
      this.current_popup.close();
      this.current -= 1;
      this.current_popup.open();
    }
  },

  mounted(){
    if(this.interacted){
      if(FORCE_CLEAR){
        this.$cookies.remove("userTutorial");
        this.current = -1;

      }else
        return;
    }

    this.$bvToast.show('user-tutorial');
  }
}
</script>

<style scoped>
#account{
  display: flex;
  flex-direction: row;
}

#account .spinner-grow{
  margin-top: 10px;
  margin-right: 10px;
  width: 25px;
  height: 15px;
}

#help{
  display: flex;
  flex-direction: row;
  font-size: 1.1rem;
}

#help img{
  margin-right: 10px;
  height: 25px;
}

#buttons{
  display: flex;
  flex-direction: row;
  justify-content: right;
}

#buttons button{
  margin: 0 5px;
}
</style>
